import { createContext } from "react";
import { BusinessSetting } from "../../../models/settings.model";

const BusinessSettingsContext = createContext<{
  settings: BusinessSetting | null | undefined;
  refreshSettings: (settingsId: string) => void;
}>({
  settings: null,
  refreshSettings: () => {
    throw new Error("Method not implemented");
  },
});

export default BusinessSettingsContext;
